import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useIntl } from "react-intl";
//import { Text } from "@mantine/core";
import SRLogo from "../assets/images/sr-logo-192x192.png";
import { useMediaQuery } from "@mantine/hooks";

export default function Header() {
  const intl = useIntl();
  const [signedIn, setSignedIn] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();
  const smallScreen = useMediaQuery("(max-width: 800px)");

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setSignedIn(true);
      } else {
        setSignedIn(false);
      }
    });
  }, [auth]);

  const pathMatchRoute = (route: any) => {
    if (route === location.pathname) {
      return true;
    }
  };

  return (
    <>
      <div className="navbar">
        <header className="header-content">
          <div className="header-logo-title">
            <img
              src={SRLogo}
              alt="Connecting businesses with experienced professionals for part-time or contract jobs"
              title="Soft Retired Home"
              className="logo"
              onClick={() => navigate("/")}
            />
            {!smallScreen && (
              <div className="header-title">
                {/* <Text size="lg" c="dark-gray">
                  {intl.formatMessage({ id: "header.motto" })}
                </Text> */}
                <h1 style={{ fontSize: "1.1rem", color: "#666" }}>
                  {intl.formatMessage({
                    id: "header.motto",
                    defaultMessage:
                      "Empowering businesses with skilled professionals seeking flexible work opportunities",
                  })}
                </h1>
              </div>
            )}
            {/* <ul className="nav-links">
              <li
                className={`nav-item ${
                  pathMatchRoute("/about") && "nav-item-active"
                }`}
                onClick={() => navigate("/about")}
              >
                {intl.formatMessage({ id: "header.about" })}
              </li>
            </ul> */}
          </div>
          <div>
            <ul className="nav-links">
              <li
                className={`nav-item ${
                  pathMatchRoute("/") && "nav-item-active"
                }`}
                onClick={() => navigate("/")}
              >
                {intl.formatMessage({ id: "header.home" })}
              </li>
              {!signedIn && (
                <li
                  className={`nav-item ${
                    pathMatchRoute("/sign-in") && "nav-item-active"
                  }`}
                  onClick={() => navigate("/sign-in")}
                >
                  {intl.formatMessage({ id: "header.signIn" })}
                </li>
              )}
              {signedIn && (
                <li
                  className={`nav-item ${
                    pathMatchRoute("/myconnections") && "nav-item-active"
                  }`}
                  onClick={() => navigate("/myconnections")}
                >
                  {intl.formatMessage({ id: "header.myConnections" })}
                </li>
              )}
              {signedIn && (
                <li
                  className={`nav-item ${
                    pathMatchRoute("/myprofile") && "nav-item-active"
                  }`}
                  onClick={() => navigate("/myprofile")}
                >
                  {intl.formatMessage({ id: "header.profile" })}
                </li>
              )}
            </ul>
          </div>
        </header>
      </div>
    </>
  );
}
